<template>
    <component v-bind:is="layout" ></component>
</template>

<script>
import Main from './layouts/Main';

export default {
  name: "App",
  components: {
    "default-layout": Main
  },
  computed: {
    layout() {
      return "default-layout";
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/scss/main.scss";
</style>
